import Papa from 'papaparse';
import axios from 'axios';

export default class Data {

    constructor(input, options, callback) {
        this.table = null;
        this.fields = []
        this.options = options;
        this.name = options.name
        this.parsingProgress = 10;
        this.loadingProgress = 10;
        if (input.dataset)
            this.loadURL(options.url, callback);
        else if (input.file)
            this.loadFile(input.file, callback);
    }

    isValid() {
        return (this.name && this.table);
    }

    static parseCSV(string, callback) {
        Papa.parse(string, {
            // worker: true,
            header: true,
            comments: '#',
            dynamicTyping: true,
            fastMode: true,
            complete(output) {
                callback(output.data, output.meta.fields);
            }
        });
    }

    getProgress() {
        return Math.min(this.parsingProgress, this.loadingProgress);
    }

    loadURL(url, callback) {
        this.loadingProgress = 10;
        axios(url)
            .then(response => {
                this.parsingProgress = 20;
                Data.parseCSV(response.data, (table, fields) => {
                    this.parsingProgress = 100;
                    this.table = table;
                    this.fields = fields;
                    let columnFilter = this.displayedColumns()
                    let stringFile = this.stringifyTable(this.table, columnFilter, this.options.delimiter)
                    this.loadingProgress = 30;
                    callback(stringFile, columnFilter);
                    this.loadingProgress = 100;
                });

            }).catch(err => {
                console.error('Something went wrong' + err);
         // TODO Visual message
        });
    }

    getTable() {
        return this.table;
    }

    stringifyTable(jsonData, columnFilter, delimiter) {
        return Papa.unparse(jsonData, {
                quotes: false, //or array of booleans
                quoteChar: '',
                escapeChar: '',
                delimiter: delimiter,
                header: true,
                columns: columnFilter,
                skipEmptyLines: 'greedy'
            }
        )
    }

    filterTable(items) {
        let rows = []
        for (let i of items) {
            rows.push(this.table[i])
        }
        return rows;
    }

    nbIndividuals() {
        if (this.table) {
            return this.table.length;
        }
        return 0;
    }

    nbColumns() {
        if (this.table) {
            return Object.keys(this.table[0]).length;
        }
        return 0;
    }

    displayedColumns() {
        if (this.options.hiddenDimensions && this.options.hiddenDimensions.length > 0 && this.fields && this.fields.length > 0) {
            return this.fields.filter(c => this.options.hiddenDimensions.indexOf(c) === -1)
        } else {
            return this.fields
        }
    }


    loadFile(file, callback) {
        this.loadingProgress = 10;
        const fileReader = new FileReader();

        fileReader.readAsBinaryString(file);
        fileReader.onload = () => {
            Data.parseCSV(fileReader.result, (table, fields) => {
                this.parsingProgress = 100;
                this.table = table;
                this.fields = fields;
                let columnFilter = this.displayedColumns()
                let stringFile = this.stringifyTable(this.table, columnFilter, this.options.delimiter)
                this.loadingProgress = 30;
                callback(stringFile, columnFilter);
                this.loadingProgress = 100;
            });


        };

        fileReader.onprogress = data => {
            if (data.lengthComputable) {
                this.loadingProgress = parseInt(((data.loaded / data.total) * 100), 10);
            }
        };

        fileReader.onerror = err => {
            console.log(err)
        };
    }
}
